var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwsCloudformation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-28 0 312 312",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.491,215.53 L18.667,218 L128.582,249.157 L129.08,229.844 L52.1,210.526 L48.333,209.167 L16.491,215.53",
    fill: "#B7CA9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.505,215.53 L127.25,253 L126.916,229.844 L203.895,210.526 L207.25,206.75 L239.505,215.53",
    fill: "#B7CA9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.916,83.165 L203.895,101.106 L237.75,99.5 L239.505,96.107 L132.25,57.5 L126.916,83.165",
    fill: "#3C4929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1,210.526 L16.491,215.53 L15.5,211.833 L15.5,100 L16.491,96.107 L48.667,98.5 L52.1,101.11 L52.1,210.526",
    fill: "#759C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.08,83.165 L52.1,101.106 L16.491,96.107 L17.833,94 L128.582,62.48 L129.08,83.165",
    fill: "#3C4929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.846,0 L0,64.531 L0.061,247.144 L127.846,311.641 L129.75,308.75 L129.75,3.75 L127.846,0 L127.846,0 Z M90.462,237.73 L16.491,215.53 L16.491,96.107 L90.462,73.915 L90.462,237.73 L90.462,237.73 Z",
    fill: "#4B612C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.895,210.526 L239.505,215.53 L241.5,212 L241.5,99.5 L239.505,96.107 L203.895,101.11 L203.895,210.526",
    fill: "#4B612C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.846,311.641 L255.939,247.148 L256,64.536 L127.846,0 L127.846,311.641 L127.846,311.641 Z M165.533,73.915 L239.505,96.107 L239.505,215.53 L165.533,237.73 L165.533,73.915 L165.533,73.915 Z",
    fill: "#759C3E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCloudformation);
export default __webpack_public_path__ + "static/media/aws-cloudformation.2028d8c4848bd23658e3609f9f24b2ac.svg";
export { ForwardRef as ReactComponent };